import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RegularExpressions } from '../constants/regular-expressions';
import { addForbiddenFeature } from '../ducks/authenticated-slice';
import { clearErrorsByCode } from '../ducks/base-api';
import { BaseApiState } from '../models/api-model';
import { AuthenticatedState, ForbiddenFeature } from '../models/authenticated-model';
import { TcsmFeatures } from '../models/features-model';
import { BaseAppState } from '../models/redux-state';

export function useForbidden(feature: TcsmFeatures) {
	const authenticatedState = useSelector<BaseAppState, AuthenticatedState>(state => state.authenticatedState);
	const baseApiState = useSelector<BaseAppState, BaseApiState>(state => state.apiState);
	const dispatch = useDispatch();

	function verifyReponse(error: AxiosError<any>) {
		if ((error.response?.status === 403) || (error.response?.status === 401) &&
			(error?.request?.responseURL.match(RegularExpressions.EmployeeDetailRequest) ||
				error?.request?.responseURL.match(RegularExpressions.EmploymentsDetailRequest) ||
				error?.request?.responseURL.match(RegularExpressions.TerminationDetailRequest) ||
			error?.request?.responseURL.match(RegularExpressions.TerminationOperationRequest) ||
			error?.request?.responseURL?.includes('/compensations.json') ||
				error?.request?.responseURL?.includes('ghl_forms/life_events')
			)) {
			return false;
		}

		return error.response?.status === 403 || error.response?.status === 401;
	}

	const featureForbidden = authenticatedState?.forbiddenFeatures?.find(x => x.feature === feature) || null;
	const api403or401 = baseApiState?.error?.find(verifyReponse);

	let newForbidden: ForbiddenFeature = null;

	useEffect(() => {
		// if 403 or 401 from api but not tracked yet, add it to the list of forbidden features
		if (!featureForbidden && !!api403or401) {
			newForbidden = {
				feature,
				code: api403or401.response?.status,
			};

			dispatch(addForbiddenFeature(newForbidden));

			// clear 403 & 401 api errors so that if we navigate to another feature, it doesn't add it as forbidden
			dispatch(clearErrorsByCode(403));
			dispatch(clearErrorsByCode(401));
		}
	}, [featureForbidden, api403or401]);


	return featureForbidden || newForbidden;
}